import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { AnnotatorSelection } from './components/DashboardComponents/AnnotatorSelection';
import { BatchProgress } from './components/DashboardComponents/BatchProgress';
import { DashboardOverallProgress } from './components/DashboardComponents/DashboardOverallProgress';
import { MetricProjectsDropdown } from './components/MetricProjectsDropdown';
import { ProjectNotSelected } from './components/ProjectNotSelected';
import { useMetricDashboard } from './useMetricDashboard';

export const MetricDashboard = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const {
    annotationProgressData,
    isAnnotationProgressDataLoading,
    annotationProgressBatchWiseData,
    isAnnotationProgressBatchWiseDataLoading,
    selectedProjectId,
  } = useMetricDashboard();
  return (
    <Box
      sx={{ p: theme.spacing(6), display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
    >
      <Box sx={{ mb: theme.spacing(12) }}>
        <Typography variant="h4">{formatMessage({ id: 'metrics.dashboard.title' })}</Typography>
      </Box>
      <MetricProjectsDropdown />
      <Box
        id="metrics-dashboard-content"
        sx={{ display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}
      >
        <AnnotatorSelection />
        {!selectedProjectId ? (
          <ProjectNotSelected />
        ) : (
          <>
            <DashboardOverallProgress
              annotationProgressData={annotationProgressData}
              isAnnotationProgressDataLoading={isAnnotationProgressDataLoading}
            />
            <BatchProgress
              annotationProgressBatchWiseData={annotationProgressBatchWiseData}
              isAnnotationProgressBatchWiseDataLoading={isAnnotationProgressBatchWiseDataLoading}
            />
          </>
        )}
      </Box>
    </Box>
  );
};
